const NETWORK_ERROR =
  /failed to fetch|network\s*error|load failed|network request failed/i;

export function saveErrorMessage(raw: unknown, fallback = "Save failed"): string {
  const text =
    typeof raw === "string"
      ? raw
      : raw instanceof Error
        ? raw.message
        : fallback;
  if (NETWORK_ERROR.test(text)) {
    return "Unable to save. Check the connection and try again.";
  }
  return text.trim() || fallback;
}
